import { safeLocalStorage } from '@toss/storage';

const FALLBACK_FP_STORAGE_KEY = 'zep.quiz.ai.fingerprint-id';

let fingerprintPromise: Promise<string | null> | null = null;

function createFallbackFingerprintId() {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }
  return `fallback-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

function getStoredFallbackFingerprintId(): string | null {
  return safeLocalStorage.get(FALLBACK_FP_STORAGE_KEY);
}

function saveFallbackFingerprintId(value: string): void {
  safeLocalStorage.set(FALLBACK_FP_STORAGE_KEY, value);
}

async function getFingerprintIdFromLibrary() {
  if (typeof window === 'undefined') return null;

  try {
    const { default: FingerprintJS } = await import(
      '@fingerprintjs/fingerprintjs'
    );
    const fpAgent = await FingerprintJS.load();
    const fpResult = await fpAgent.get();
    return fpResult.visitorId ?? null;
  } catch {
    return null;
  }
}

export async function getClientFingerprintId() {
  if (typeof window === 'undefined') return null;

  const storedFallbackId = getStoredFallbackFingerprintId();
  if (storedFallbackId) return storedFallbackId;

  if (!fingerprintPromise) {
    fingerprintPromise = getFingerprintIdFromLibrary();
  }

  const libraryFpId = await fingerprintPromise;
  if (libraryFpId) return libraryFpId;

  const fallbackId = createFallbackFingerprintId();
  saveFallbackFingerprintId(fallbackId);
  return fallbackId;
}
